import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface ErrorDialogData {
  errorCode: string;
}

@Component({
  selector: 'app-error-dialog',
  imports: [ButtonModule],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.css',
})
export class ErrorDialogComponent {

  constructor(public dynamicDialogConfig : DynamicDialogConfig<ErrorDialogData>) {}

  onClickRefresh() {
    window.location.reload();
  }
}
